module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    attrs: {
      "label": "Comscore File",
      "filled": _vm.disabled,
      "outlined": "",
      "disabled": _vm.disabled,
      "dense": "",
      "clearable": "",
      "items": _vm.sortedOptions,
      "item-text": "Name",
      "item-value": "value",
      "search-input": _vm.search,
      "return-object": "",
      "hide-details": "true"
    },
    on: {
      "input": function (val) { return _vm.$emit('update', val); },
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348f4e1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/ComscoreSelect.vue
// module id = 1861
// module chunks = 0